module.exports = __webpack_public_path__ + "static/media/product.7c85ab06.svg";